import { useEffect, useState, useRef } from "react";
import { FiEdit } from "react-icons/fi";
import { useStores } from "../../store";
import { uploadFileToAzure } from "../../services/azure";
import constantVariables from "../../helpers/constantVariables";

export function Prof(props) {
  const { UserStore } = useStores();
  const fileInputRef = useRef(null);

  const userGoogleDetails = JSON.parse(localStorage.getItem("user"));
  const [profile, setProfile] = useState(userGoogleDetails?.pic);

  useEffect(() => {
    if (UserStore.userPic) {
      setProfile(UserStore.userPic);
    } else {
      setProfile(userGoogleDetails?.pic);
    }
  }, [UserStore.userPic]);

  useEffect(() => {
    setProfile(userGoogleDetails?.pic);
  }, []);

  const defaultProfile =
    "https://t4.ftcdn.net/jpg/02/15/84/43/360_F_215844325_ttX9YiIIyeaR7Ne6EaLLjMAmy4GvPC69.jpg";

  const handleFileChange = async (e) => {
    try {
      const timestamp = Date.now().toString();
      const min = 1000;
      const max = 9999;
      const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
      const filename = randomNumber + timestamp;

      const fileUploaded = await uploadFileToAzure(
        filename,
        e.target.files[0],
        { action: "profile" }
      );

      const stringifiedURL = JSON.stringify(fileUploaded.url);
      localStorage.setItem("pic", stringifiedURL);
      setProfile(fileUploaded.url);
      const sidebarProfilePic = document.getElementById("SidebarProfilePic");
      if (sidebarProfilePic) {
        sidebarProfilePic.src = fileUploaded.url;
      }

      UserStore.setUserPic(fileUploaded.url);

      let body = { pic: fileUploaded.url };
      await UserStore.updateUserDetailsToServer(body).then((res) => {
        console.log(res);
      });
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  return (
    <div className="relative">
      <input
        type="file"
        accept=".png, .jpeg, .jpg"
        className="hidden"
        ref={fileInputRef}
        multiple={false}
        onChange={handleFileChange}
      />

      <div className="relative inline-block">
        <img
          src={`${profile || defaultProfile}`}
          alt=" "
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = constantVariables.defaultProfilePic;
          }}
          className={`w-[${props.size ?? "80px"}] h-[${
            props.size ?? "80px"
          }] border border-primary cursor-pointer rounded-full`}
          style={{
            // backgroundImage: `url(${defaultProfile})`,
            backgroundColor: "white",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          onClick={() => fileInputRef.current.click()}
        />

        <button
          onClick={() => fileInputRef.current.click()}
          className="absolute bottom-0 right-0 transform translate-x-2 translate-y-2 focus:outline-none"
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
          }}
        >
          <span
            className={`${
              props.size
                ? "absolute right-0 -mt-5 lg:right-3 lg:-mt-8 transform -translate-x-5 -translate-y-3  bg-[#FFB279]  rounded-full h-6 w-6 lg:h-7 lg:w-7 "
                : "absolute right-0 -mt-5 lg:right-3 lg:-mt-8 transform -translate-x-2 -translate-y-2  bg-white rounded-full h-5 w-5 lg:h-7 lg:w-7 "
            }`}
          >
            <FiEdit
              className={`${
                props.size
                  ? "h-3 w-[1.6rem] text-md lg:h-4 lg:w-4 absolute top-[25%] right-0 lg:right-1"
                  : "h-2 w-[1.5rem] lg:h-4 lg:w-4 absolute top-[25%] right-0 lg:right-1"
              }`}
            />
          </span>
        </button>
      </div>
    </div>
  );
}
